// extracted by mini-css-extract-plugin
module.exports = {"tab":"tab_tab__zPE9a","active":"tab_active__fViCV"};